<head>
  <meta name="viewport" content="width=device-width, initial-scale=1">
</head>
<template>
  <div class="Evaluation-modal-overlay">
    <div class="Evaluation-modal" @click.stop>
      <div class="search-container">
        <h3 style="font-size: 1.5rem; margin-bottom: 10px;">Assign Instructors to Session ID: {{ this.selectedProjectId
          }}</h3>
        <input type="text" style="width: 40%;" v-model="searchQuery" placeholder="Search by Name" />
      </div>
      <div class="pagination-button-container">
        <div class="pagination-container">
          <Pagination :totalPages="totalPages" :perPage="perPage" :currentPage="currentPage"
            @page-change="onPageChange" />
        </div>
        <div class="pagination-info">
          Showing {{ startIndex + 1 }}-{{ endIndex }} of {{ filteredInstructorsLength }} instructors
        </div>
      </div>
      <div class="container-fluid">
        <table class="data-table-trainee">
          <thead>
            <tr>
              <th @click="sortBy('user_id')">
                ID
                <span v-if="sortField === 'user_id'" v-html="getFieldArrow()"></span>
              </th>
              <th @click="sortBy('first_name')">
                First Name
                <span v-if="sortField === 'first_name'" v-html="getFieldArrow('first_name')"></span>
              </th>
              <th>Last Name</th>
              <th>Email</th>
              <th style="width: 120px;">Assign Instructor</th>
              <th style="width: 140px;">Un-assign Instructor</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in filteredInstructors" :key="item.user_id">
              <td>{{ item.user_id }}</td>
              <td>{{ item.first_name }}</td>
              <td>{{ item.last_name }}</td>
              <td>{{ item.email }} </td>
              <td class="center-icons" @click="toggleCheckbox(item.user_id)">
                <input type="checkbox" v-model="selectedInstructors" :value="item.user_id"
                  :disabled="alreadyAssignedInstructors.includes(item.user_id)" @click.stop>
              </td>
              <td class="center-icons">
                <i class="fas fa-trash-alt delete-icon" v-if="alreadyAssignedInstructors.includes(item.user_id)"
                  @click="removeInstructor(item.user_id)"></i>
              </td>
            </tr>
            <tr v-if="filteredInstructors.length === 0">
              <td colspan="100" style="text-align: center;">No Matching Instructors</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="button-container">
        <button class="ins-close-button" @click="close()">Close</button>
        <button class="btn btn-primary rounded" @click="assignSelectedInstructors">Assign Instructors</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import Pagination from '../TablePagination.vue';


export default {
  name: 'AssignInstructorsModal',
  components: {
    Pagination,
  },
  props: {
    selectedProjectId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      instructors: [],
      selectedInstructors: [],
      sortField: 'user_id',
      sortDirection: 'asc',
      searchQuery: '',
      projectSearchQuery: '',
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      newProject: {
        name: '',
        prod_id: '',
        product_name: '',
        user_id: '',
      },
      filteredInstructorsLength: 0,
      alreadyAssignedInstructors: '',
    };
  },
  computed: {
    startIndex() {
      return (this.currentPage - 1) * this.perPage;
    },
    endIndex() {
      const end = this.startIndex + this.perPage;
      return end < this.filteredInstructorsLength ? end : this.filteredInstructorsLength;
    },
    filteredInstructors() {
      return this.computeFilteredInstructors();
    },
  },
  watch: {
    searchQuery(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.currentPage = 1; // Reset currentPage to 1 when searchQuery changes
      }
    },
  },
  methods: {
    close() {
      this.$emit('close');
    },
    toggleCheckbox(userId) {
      if (this.alreadyAssignedInstructors.includes(userId)) return;

      const index = this.selectedInstructors.indexOf(userId);
      if (index > -1) {
        this.selectedInstructors.splice(index, 1);
      } else {
        this.selectedInstructors.push(userId);
      }
    },
    editInstructor(user_id) {
      window.location.href = `/instructors/${user_id}`;
    },
    sortBy(field) {
      if (this.sortField === field) {
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        this.sortField = field;
        this.sortDirection = 'asc';
      }

      this.instructors.sort((a, b) => {
        const valueA = a[field];
        const valueB = b[field];

        if (typeof valueA === 'number' && typeof valueB === 'number') {
          return (this.sortDirection === 'asc' ? 1 : -1) * (valueA - valueB);
        } else if (typeof valueA === 'string' && typeof valueB === 'string') {
          return (this.sortDirection === 'asc' ? 1 : -1) * valueA.localeCompare(valueB);
        } else {
          return 0;
        }
      });
    },
    getFieldArrow(field = 'user_id') {
      if (this.sortField === field) {
        return this.sortDirection === 'asc' ? '▲' : '▼';
      } else {
        return '';
      }
    },
    onPageChange(page) {
      this.currentPage = page;
    },
    assignSelectedInstructors() {
      if (this.selectedInstructors.length === 0) {
        return;
      }

      const project_id = this.selectedProjectId;
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      axios.get(`/api/projects/${project_id}/users`, { headers })
        .then((response) => {
          const existingInstructors = response.data.map((instructor) => instructor.user_id);

          // Filter out instructors already assigned to the project
          const newInstructors = this.selectedInstructors.filter(instructorId => !existingInstructors.includes(instructorId));
          console.log(newInstructors);
          if (newInstructors.length === 0) {
            window.alert('All selected instructors are already in the Session.');
            this.selectedInstructors = [];
            return;
          }

          // Step 2: Assign new instructors to the Session
          const projectData = {
            user_ids: newInstructors,
            role: 'instructor'
          };

          return axios.post(`/api/projects/${project_id}/add-users`, projectData, { headers })
            .then((response) => {
              console.log('Instructors added to the Session:', response);

              return axios.get(`/api/projects/${project_id}/logbooks`, { headers });
            })
            .then((logbookResponse) => {
              const logbooks = logbookResponse.data;
              const logbookIds = logbooks.map((logbook) => logbook.logbook_id);

              const logbookData = {
                user_ids: newInstructors,
                logbook_ids: logbookIds,
                project_id,
              };

              return axios.post(`/api/logbooks/add-users-to-logbook`, logbookData, { headers });
            });
        })
        .then((logbookAssignResponse) => {
          if (logbookAssignResponse) {
            console.log('Instructors added to logbooks:', logbookAssignResponse);
            window.alert('Instructors added successfully to the Session and logbooks.');
          }
          this.selectedInstructors = [];
          this.$emit('close');
        })
        .catch(error => {
          console.error('Error assigning instructors or fetching logbooks:', error);
          if (error.isOffline === true) {
            this.$emit('close');
            return;
          }
          if (error.response && error.response.data && error.response.data.message === "No logbooks found for this Session") {
            window.alert('Instructors added successfully to the Session.');
            // Logbooks are not found, but instructors are still assigned to the Session.
            this.selectedInstructors = [];
            this.$emit('close');
            return;
          }
          // Handle other errors, e.g., display an error message.
          window.alert('An error occurred while assigning instructors. Please try again.');
        });

    },
    async removeInstructor(user_id) {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        // You may want to show a confirmation dialog before removing the instructor
        const confirmRemove = confirm('Are you sure you want to remove this instructor from the Session?');

        if (!confirmRemove) {
          return;
        }

        // Send a DELETE request to your API to remove the instructor from the Session
        const response = await axios.delete(`/api/users/${user_id}/projects/${this.selectedProjectId}`, { headers });

        if (response.status === 200) {
          window.alert('Instructor successfully removed from Session.');
          this.loadData()
        } else {
          // Handle errors here
          console.error('An error occurred while removing the instructor:', response);
        }
      } catch (error) {
        console.error('An error occurred while removing the instructor:', error);
        if (error.isOffline === true) {
          this.$emit('close');
          return;
        }
      }
    },
    goBack() {
      this.$router.push({ name: 'ViewProjects' });
    },
    calculateTotalPages() {
      this.computeFilteredInstructors();
      this.totalPages = Math.ceil(this.filteredInstructorsLength / this.perPage);
    },
    computeFilteredInstructors() {
      const startIndex = (this.currentPage - 1) * this.perPage;
      const endIndex = startIndex + this.perPage;

      const filteredInstructors = this.instructors.filter((instructor) => {
        const fullName = (instructor.first_name + instructor.last_name || "").toLowerCase(); // Fallback to empty string if null or undefined
        const instructorMatch = fullName.includes(this.searchQuery.toLowerCase()) || this.searchQuery === '';

        return instructorMatch
      });

      console.log(filteredInstructors);
      this.filteredInstructorsLength = filteredInstructors.length;
      console.log(this.filteredInstructorsLength);
      return filteredInstructors.slice(startIndex, endIndex);
    },
    async loadData() {
      try {
        const token = localStorage.getItem('token');
        const headers = { Authorization: `Bearer ${token}` };

        // Fetch the instructors assigned to the project
        const response = await axios.get(`/api/projects/${this.selectedProjectId}/users`, { headers });
        const assignedInstructors = response.data;
        this.alreadyAssignedInstructors = response.data.map(instructor => instructor.user_id);

        // Now, you have the assigned instructors in the 'assignedInstructors' variable.
        console.log(assignedInstructors);

        // Fetch all instructors (including those assigned to the project)
        const result = await axios.get('/api/users', { headers });

        if (result.status === 200) {
          // Filter the response data to include only users with the role 'instructor'
          this.instructors = result.data.filter(user => user.role === 'instructor');

          this.selectedInstructors = [...this.alreadyAssignedInstructors];
        }

        this.totalPages = Math.ceil(this.instructors.length / this.perPage);

      } catch (error) {
        console.error('An error occurred while fetching data:', error);
      }
    }
  },
  async mounted() {
    this.loadData();
  },
};
</script>

<style scoped>
.close-button {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
}

.modal-body {
  margin-bottom: 20px;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
}

.confirm-button,
.cancel-button {
  padding: 10px 15px;
  margin-left: 10px;
  border: none;
  border-radius: 4px;
  cursor: pointer;
}

.confirm-button {
  background-color: #28a745;
  color: white;
}

.cancel-button {
  background-color: #dc3545;
  color: white;
}

.trainee-table {
  width: 100%;
  border-collapse: collapse;
}

.trainee-table th,
.trainee-table td {
  padding: 10px;
  border: 1px solid #ddd;
}

.trainee-table th {
  background-color: #f4f4f4;
}

.Evaluation-modal-overlay {
  position: absolute;
  top: 0px;
  left: 0;
  background-color: rgba(97, 94, 94, 0.5);
  display: flex;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  z-index: 1;
}

.Evaluation-modal {
  background-color: #ffffff;
  overflow-y: auto;
  /* Enables vertical scrolling if needed */
  margin-top: 85px;
  max-width: 90vw;
  max-height: 84vh;
  min-width: max(65vw, 1100px);
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.2);
  position: fixed;
  display: flex;
  flex-direction: column;
  overflow-wrap: break-word;
  padding: 20px;
  z-index: 1002;
}

.modal-title {
  text-align: center;
  margin-bottom: 20px;
}

.assessment-table {
  width: 90%;
  border-collapse: collapse;
  align-items: center;
  margin: 0 auto;
}

.assessment-table th,
.assessment-table td {
  border: 1px solid #ddd;
  padding: 3px;
  text-align: left;
  font-size: 14px;
}

.assessment-table thead th {
  background-color: #f2f2f2;
  font-size: 15px;
}

.signature-section {
  margin-top: 20px;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.signature-item label {
  width: 40%;
  display: block;
  margin-bottom: 5px;
}

.signature-placeholder,
.date-placeholder {
  border: 1px solid #ddd;
  padding: 5px;
  min-height: 30px;
  /* Adjust as needed */
}

.button-container {
  display: flex;
  justify-content: space-between;
  /* Aligns items to the right */
  align-items: center;
}

.ins-save-button {
  background-color: #007bff;
  border-color: #007bff;
  color: white;
  border: none;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 10px;
  margin-left: 20px;
  width: 100%;
  min-width: 90px;
  max-width: 100px;
}

.ins-submit-button {
  background-color: brown;
  border: 1px solid rgb(92, 23, 23);
  color: white;
  cursor: pointer;
  border-radius: 5px;
  padding: 5px 20px;
  min-width: 100px;
  max-width: 120px;
  margin-right: 5%;
  height: 35px;
}

.ins-close-button {
  background-color: #6c757d;
  border: 1px solid #4d5358;
  color: white;
  padding: 5px 20px;
  border-radius: 5px;
  margin-left: 5%;
}

.ins-close-button:hover {
  background-color: #4d5358;
}

.ins-clear-button {
  background-color: #f0ac9c;
  color: white;
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 0;
  width: 100%;
  min-width: 140px;
  max-width: 150px;
  border: 1px solid #c7715e;
}

.ins-save-button:disabled,
.ins-submit-button:disabled,
.ins-clear-button:disabled {
  background-color: rgb(216, 216, 216);
  cursor: not-allowed;
  color: grey
}

.ins-save-button:disabled:hover,
.ins-submit-button:disabled:hover,
.ins-clear-button:disabled:hover {
  background-color: rgb(216, 216, 216);
  color: grey
}

.ins-submit-button:hover {
  background-color: rgb(129, 33, 33);
}

.assessment-result {
  margin-left: 25%;
}

.task-performance {
  width: 50%;
  border-collapse: collapse;
  text-align: left;
  background-color: #f2f2f2;
  margin-left: 20px;
}

.task-performance th {
  /* Adjust the color to match your header background */
  font-weight: bold;
}


.task-performance input[type="text"] {
  width: 100%;
  border: none;
  padding: 4px;
  text-align: center;
  background-color: #f2f2f2;
}

.assessment-container {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-top: 20px;
}


.signature-block {
  display: flex;
  flex-direction: column;
  margin-right: 70px;
}


.signature-table {
  width: 100%;
}

.signature-table td {
  padding: 4px;
  /* Adjust padding as needed */
  vertical-align: middle;
  /* Aligns content of <td> vertically in the middle */
}

.signature-table .signature {
  text-align: left;
  /* Aligns the text to the left */
}

.trainee-signature {
  text-align: left;
}

.signature-table input[type="text"],
.signature-table input[type="date"] {
  width: 100%;
  border: none;
  border-bottom: 1px solid black;
  border-radius: 0px;
  background-color: transparent;
  outline: none;
  height: 20px;
}

@media (max-width: 768px) {

  /* Adjust the max-width as needed for iPad or other tablet sizes */
  .Evaluation-modal {
    padding: 5px;
    font-size: 0.9em;
    /* Reduce font size */
  }

  /* Further adjustments for other elements */
}


#selectAllSatisfactory {
  margin-left: 5px;
  border: 1px solid rgb(206, 13, 13);
}

.signature-pad {
  border-bottom: 1px solid #000;
  border-radius: 5px;
}

.right {
  display: flex;
  justify-content: flex-end;
  margin-right: 5%;
}

/* Add this CSS to your stylesheet */
.signature-image-wrapper {
  position: relative;
  display: inline-block;
}

.signature-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: transparent;
  pointer-events: none;
  /* Prevents interaction with the overlay */
}

.disabled {
  opacity: 0.5;
  /* Optionally reduce opacity to indicate disabled state */
}

.assess-button {
  border: 1px solid #555c57;
  border-radius: 2px;
  background-color: #d6d6d6;
}

.assess-button:hover {
  background-color: rgb(180, 180, 180);
}

.assess-button:disabled:hover {
  cursor: not-allowed;
}

.pass-button {
  border: 1px solid #507458;
  border-radius: 2px;
  background-color: #b0e6bd;
  color: #075e1a;
}

.pass-button:hover {
  background-color: #82d896;
}

.fail-button {
  border: 1px solid #745050;
  border-radius: 2px;
  background-color: #e6b0b0;
  color: #7a0606;
}

.fail-button:hover {
  background-color: #d88282;
}

.in-progress-button {
  border: 1px solid #a06e36;
  border-radius: 2px;
  background-color: #e4d09c;
  color: #724400;
}

.in-progress-button:hover {
  background-color: #d8b382;
}

.missing-task {
  background-color: #fce2e4;
  /* Light red background for missing tasks */
}

span:hover {
  cursor: pointer;
  color: blue;
}

.pagination-container {
  display: flex;
  margin-left: 3%;
}

.container-fluid {
  padding-top: 5px;
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;
}

.search-container {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  font-size: 16px;
  width: 80%;
}

button.btn {
  padding: 10px 10px;
  font-size: 16px;
  width: 180px;
  height: 40px;
  margin-top: 0%;
  margin-bottom: 0px;
  border: 1px solid rgb(0, 45, 63);
  background: #2952c4;
  color: white;
  cursor: pointer;
  text-align: center;
  transition: transform 0.2s, box-shadow 0.2s;
  float: right;
  margin-right: 30px;
}

button.btn:hover {
  background-color: #0c1a61;
  transition: transform 0.2s, box-shadow 0.2s;
}

.heading h1 {
  padding-top: 30px;
  padding-bottom: 10px;
  text-align: center;
  padding-left: 3%;

}

.back-button {
  /* Adjust the right position as needed */
  width: 100px;
  border-radius: 5px;
  background-color: #c1e0bf;
  float: left;
  margin-left: 30px;
  border: 2px solid black;
  padding: 3px;
}

button:hover {
  background-color: #7c927a;
  transition: transform 0.2s, box-shadow 0.2s;
}

.back-button:hover {
  background-color: #abc7a9;
  cursor: pointer;
}

.pagination-info {
  font-size: 14px;
  color: #666;
  /* Adjust the color as needed */
  position: absolute;
  top: 100px;
  left: 50%;
  /* Center horizontally */
  transform: translateX(-50%);
  /* Center horizontally */
}

/* Data table styles */
.data-table-trainee {
  width: 99%;
  margin-left: 0.5%;
  margin-right: 0.5%;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
  border-collapse: collapse;
  margin-top: 0;
  align-items: left;
  margin-bottom: 30px;
}

.data-table-trainee th {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  color: rgb(107, 107, 107);
  background-color: rgba(219, 219, 219, 0.804);
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee tbody tr:nth-child(odd) {
  background-color: white;
}

.data-table-trainee tbody tr:nth-child(even) {
  background-color: rgba(219, 219, 219, 0.804);
}


.data-table-trainee td {
  border: 1px solid #000000bf;
  padding: 10px 5px;
  text-align: left;
  font-weight: 500;
  margin-top: 0;
  font-family: 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Open Sans', 'Helvetica Neue', sans-serif;
  font-size: 14px;
}

.data-table-trainee,
.data-table-trainee th,
.data-table-trainee td {
  border: 1px solid black;
}

.data-table-trainee th,
.data-table-trainee td {
  padding: 8px;
}

.data-table-trainee td.center-icons {
  text-align: center;
}

.delete-icon {
  font-size: 16px;
  color: #FF0000;
  /* Red color */
  cursor: pointer;
  transition: color 0.2s, transform 0.2s, box-shadow 0.2s;
}

.delete-icon:hover {
  color: #a82222;
  /* Lighter red color on hover */
  cursor: pointer;
  transform: scale(1.1);
  /* Scale the icon on hover */
  /* You can also add a box-shadow or any other styles you prefer */
}
</style>